module.exports = __webpack_public_path__ + "static/img/sil.4f868f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sil.png
// module id = HyMQ
// module chunks = 0